import {connect} from "react-redux";
import {RootState, ThunkDispatch} from "../types";
import {routerTools, Routes} from "../utils/router";
import {doGetTimestamps, doTimestamp} from "../actions/thunks/signatures";
import {DispatchProps, InnerProps, StateProps, Timestamps} from "../components/Timestamps";
import {userIsAllowed} from "../utils/commons";
import {gotTimestamps} from "../actions/signatures";
import {doGetUserCredits} from "../actions/thunks/users";

function mapStateToProps({user, timestamp}: RootState): StateProps {
    return {
        apiKeys: user.credentials,
        timestamps: timestamp.timestamps,
        total: timestamp.total,
        stats: user.credits?.timestamp_api,
        isAllowed: userIsAllowed(user.credits, "timestamp_api"),
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onGoToDocumentation: () => window.open(Routes.DOCS, "_blank"),
        onGoToApiKeys: () => routerTools.push(Routes.API_KEYS),
        onGetTimestamps: (q) => dispatch(doGetTimestamps(q)),
        onResetTimestamps: () => dispatch(gotTimestamps({items: undefined as any, total: 0})),
        onDoTimestamp: (file, trusted) => dispatch(doTimestamp(file, trusted)),
        onGetUserCredits: () => dispatch(doGetUserCredits()),
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(Timestamps);
